var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.743,
    height: 62.69,
    viewBox: "0 0 61.743 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Upload_4100550",
    transform: "translate(-14.9 -26.357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M38.6,63.95a2.7,2.7,0,0,0,2.7-2.7v-37.8l8.53,8.322a2.7,2.7,0,0,0,3.767-3.866L40.483,15.124a2.7,2.7,0,0,0-3.8.036L24.05,27.949a2.7,2.7,0,1,0,3.841,3.79L35.9,23.629V61.252a2.7,2.7,0,0,0,2.7,2.7Z",
    transform: "translate(6.689 12)",
    fill: "$color8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M73.944,43.937a2.7,2.7,0,0,0-2.7,2.7V59.119a.9.9,0,0,1-.9.9H21.2a.9.9,0,0,1-.9-.9V46.635a2.7,2.7,0,0,0-5.4,0V59.119a6.305,6.305,0,0,0,6.3,6.3h49.15a6.305,6.305,0,0,0,6.3-6.3V46.635A2.7,2.7,0,0,0,73.944,43.937Z",
    transform: "translate(0 23.631)",
    fill: "$color8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.18c9c8d579b682d8928de1ce594f0302.svg";
export { ForwardRef as ReactComponent };